export default {
  setInformation: 'MAIN_MUTATIONS_SETINFORMATION',
  setInformationTimeoutChecker: 'MAIN_MUTATIONS_SETINFORMATION_TIMEOUT_CHECKER'
}
